import { useQuery } from '@tanstack/react-query';
import { publicPlansService, PublicPlan } from '@/services/publicPlansService';

export function usePublicPlans(country: 'BR' | 'UK') {
  return useQuery<PublicPlan[]>({
    queryKey: ['public', 'plans', country],
    queryFn: () => publicPlansService.getPlans(country),
    staleTime: 1000 * 60 * 10, // 10 minutes - plans don't change often
  });
}
